import React, { useRef } from 'react'
import TBBImage from 'utils/TBBImage'
import RichText from 'utils/RichText'
import InView from 'utils/InView'

const LogoBlock = ({blok}) => {
    // Detect if the component is in view
    const ref = useRef();
    const isVisible = InView(ref, false);

    return (
        <div className="my-12 lg:my-24" ref={ref}>
            <div className="mx-auto px-6 lg:px-12 max-w-7xl">
                <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 mt-20 items-end'>
                    {blok.items && blok.items.map((item, index) => (
                        <div 
                            className={`col-span-1 duration-500 ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-10 opacity-0'}`}
                            style={{transitionDelay: `${index+5}00ms`}}
                        >
                            <TBBImage className="h-auto mx-auto md:mx-0" image={item.image} />
                        </div>
                    ))}
                </div>
                <div className="max-w-lg">
                    <RichText>
                        {blok.outro_text}
                    </RichText>
                </div>
            </div>
        </div>
    )
};

export default LogoBlock;